
const digest = 'db0b7e93c19ba1cb1897e1003142537870580ab033b02d923bc6d1bf85f26141';
const classes = {"wrapper":"_wrapper_1gnxw_1"};
const css = `._wrapper_1gnxw_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_1gnxw_1 .reactSelect__single-value {
  contain: inline-size;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  